import React, { useState } from "react";
import { FaRegTimesCircle } from "react-icons/fa";


export default function useModal() {
    const [modalIsHidden, setModalIsHidden] = useState(true);

    const hideModal = () => setModalIsHidden(true);
    const showModal = () => setModalIsHidden(false);

    const Modal = ({children}) => (
      <>
        {!modalIsHidden && (
          <div className="static text-black">
            <div className="fixed z-10 inset-0 bg-black/60">
              <div className="w-full h-full flex justify-center items-center shadow-xl">
                <div className="bg-white/90 rounded mx-4 mb-4 mt-20 md:m-0 md:w-1/2 text-center p-2">
                  <div className="text-right">
                    <button
                      onClick={hideModal}
                      className="text-right text-gray-500 hover:text-gray-800"
                    >
                      <FaRegTimesCircle />
                    </button>
                  </div>
                  {children}
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
    
    return {Modal, modalIsHidden, setModalIsHidden, hideModal, showModal}
}